import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Intro = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem("ms-intro-seen")) return;
        setShow(true);
        document.body.style.overflow = "hidden";
        const t = setTimeout(() => {
            setShow(false);
            sessionStorage.setItem("ms-intro-seen", "1");
            document.body.style.overflow = "";
        }, 2400);
        return () => {
            clearTimeout(t);
            document.body.style.overflow = "";
        };
    }, []);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0D20]"
                    data-testid="site-intro"
                >
                    <motion.img
                        src="/assets/logo-ms-group-white.png"
                        alt="MS Group"
                        initial={{ opacity: 0, scale: 0.9, filter: "blur(10px)" }}
                        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
                        transition={{ duration: 1.1, ease: EASE }}
                        className="h-28 w-auto object-contain md:h-36"
                        data-testid="intro-logo"
                    />
                    <div className="mt-8 h-px w-40 overflow-hidden bg-white/15 md:w-56">
                        <motion.div
                            initial={{ x: "-100%" }}
                            animate={{ x: "0%" }}
                            transition={{ duration: 1.6, ease: "easeInOut", delay: 0.25 }}
                            className="h-full bg-[#F16622]"
                        />
                    </div>
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8, delay: 0.7 }}
                        className="mt-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-white/50"
                    >
                        Strong Roots · Diverse Businesses · One Vision
                    </motion.p>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
